import moment from 'moment';
import React from 'react';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import momentLocaliser from 'react-widgets/lib/localizers/moment';
momentLocaliser(moment);

const DateTimeField = ({ input, label, meta: { error, dirty }, disabled, dateTimeFormat, time, min, max }) => {
    const cls = error ? 'datepicker-error form-group' : 'form-group';
    return(
        <div className={label ? cls : undefined}>
            {label && <label className='control-label col-sm-3'>{label}</label>}
            <div className={label ? 'controls col-sm-9' : undefined}></div>
            <DateTimePicker {...input}
                onChange={input.onChange}
                format={dateTimeFormat}
                timeFormat='HH:mm'
                time={time}
                step={1}
                value={input.value ? moment(input.value, 'DD.MM.YYYY HH:mm').toDate() : null} />
            {error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>}
        </div>
    );
}

export default DateTimeField;


// WEBPACK FOOTER //
// ./src/components/orders/DateTimePicker.jsx